export const Know_More_Learner = {
  title:
    "Turn your classroom knowledge into real-world experience. At v18hub, you'll work on real industry and research-grade problems, build functional prototypes, and learn from mentors while collaborating with peers including working professionals.",

  stat_hook: {
    stat: "90%+",
    context:
      "of students we spoke across 18 colleges defaulted to web development because it seemed easier and was senior recommended, while high-impact fields like AI, ML, Computer Vision, and GenAI were seldom evaluated as long-term career choices.\n\nMeanwhile, the industry has transformed. Automation is reshaping entry-level roles, and the demand is rising for those who can design, build, and deploy intelligent systems.",
    footnote: "Primary research across 200+ students, 18 colleges PAN India.",
  },

  outcomes: [
    {
      label: "Resume-grade AI projects",
      desc: "Not certificates, build a solid understanding of foundational concepts that support long-term growth along with actual GitHub-documented portfolios.",
    },
    {
      label: "Confidence with modern AI stacks",
      desc: "Technical grounding in how modern AI systems are structured, optimized, and deployed.",
    },
    {
      label: "Research mindset",
      desc: "Every cohort ends with open research topics to explore.",
    },
    {
      label: "Internship & Industry Exposure",
      desc: "Committed learners receive internship support, interview opportunities, and industry-oriented guidance based on performance, consistency, and project involvement.",
    },
  ],

  foundational_note: {
    heading: "Not sure if you're ready?",
    desc: "Begin with workshops or bootcamps to build strong foundations in Python, ML, DL, and GenAI. Explore Preview Cohorts for short cohort experiences before committing to full-scale cohort programs. No pressure. Just a beginning.",
    // cta_label: "Learn about Programs",
    // cta_href: "/programs/preview-cohorts",
  },

  how_does_it_work: [
    {
      inner_title: "Discover Programs",
      inner_desc:
        "Browse through our programs, from Workshops to advanced cohorts and find the one that matches where you are right now. \n Not sure where to start? Workshops and bootcamps help to build foundations in ML, DL and GenAI. Preview Cohorts is a low-risk, fully refundable (within one week) way to begin before committing to full cohort.",
      img: "/Images/explore_cohorts.png",
      img_alt: "Student browsing AI and machine learning programs on v18hub",
    },
    {
      inner_title: "Explore Program details & Secure your Spot",
      inner_desc:
        "Learn about each programs timeline, milestones, and the mentors guiding you. Understand the problem you'll be solving, the tools you'll use, and the research papers you'll read along the way. \n Register for your chosen program and get ready to start your journey. Our programs are designed to support your academic schedule, including brief exam breaks.",
      img: "/Images/register_now.png",
      img_alt: "Learner reviewing cohort timeline, milestones and mentor profiles on v18hub",
    },
    {
      inner_title: "Build, Collaborate & Grow",
      inner_desc:
        "Collaborate with peers and engage with mentors, and build solutions that matter. Document your work through code, evaluations, observations, and flow diagrams on GitHub. \n Past cohort learners have gone on to represent their work at the GHCI-2025 and attended IISc workshops. Learning doesn't stop when the programs end - you continue through self-paced research topics with the support of the community.",
      img: "/Images/dive_into_details.png",
      img_alt: "Student registering for a project-based AI cohort on v18hub",
    },
    {
      inner_title: "Internship & Industry Exposure",
      inner_desc:
        "Committed learners receive internship support, interview opportunities, and industry-oriented guidance based on their consistency, involvement in cohorts, and performance throughout the programs.",
      img: "/Images/learn_by_doing.png",
      img_alt: "Students collaborating on a real-world AI project with mentor guidance at v18hub",
    },
  ],

  cta: [
    {
      button1: { label: "Explore Programs", href: "/programs" },
      // button2: { label: "Join as a Learner", href: "/registration/learner" },
    },
  ],
};
